import { useState } from "react";
import Input from "../components/Input"; 
import { T } from "../constants/theme";
import Btn from "../components/Btn";
import Badge from "../components/Badge";
import StepBar from "../components/StepBar"


export default function PaymentSuccessStep({ onNext }) {
  return (
  <div style={{ textAlign: "center", padding: "30px 0 10px" }}>
    <StepBar step={4} />

    <div style={{ fontSize: 52, marginBottom: 16 }}>🎉</div>

    <h2
      style={{
        fontSize: 22,

        fontWeight: 900,

        color: T.indigo,

        marginBottom: 8,
      }}
    >
      Payment Successful!
    </h2>

    <p style={{ fontSize: 14, color: T.gray600, marginBottom: 28 }}>
      Your registration payment of ₹289 has been completed successfully.
    </p>

    <div
      style={{
        background: T.greenLight,

        border: `1px solid ${T.green}30`,

        borderRadius: 10,

        padding: "14px 18px",

        marginBottom: 26,

        textAlign: "left",

        display: "flex",

        alignItems: "center",

        gap: 12,
      }}
    >
      <span style={{ fontSize: 22 }}>✅</span>

      <div>
        <div style={{ fontWeight: 700, color: T.green, fontSize: 14 }}>
          Transaction Confirmed
        </div>

        <div style={{ fontSize: 12, color: T.gray600, marginTop: 2 }}>
          ₹289 paid via Razorpay · Reference generated
        </div>
      </div>
    </div>

    <Btn onClick={onNext} full>
      Complete Registration →
    </Btn>
  </div>
);
}